export default __webpack_public_path__ + "static/media/relax.27a2e0d5.png";